"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabQuoteTimeChart = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
var tab2_1 = require("../tab2");
var mini_time_chart_1 = require("../mini_time_chart");
/**
 * Tab行情分时图
 * @returns
 */
function TabQuoteTimeChart(props) {
    return (react_1.default.createElement("div", { className: "tabquotechart" },
        react_1.default.createElement(tab2_1.Tab2, { tab_fill: 'full', boxdata: props.data.map(function (v) {
                return {
                    tab_html: react_1.default.createElement("span", null, v.title),
                    body: react_1.default.createElement("div", { className: "charts" },
                        react_1.default.createElement(mini_time_chart_1.MiniTimeChart, { quotecode: v.quotecode, key: v.quotecode }))
                };
            }), defaultindex: props.defaultindex, changeTabCallback: props.changeTabCallback })));
}
exports.TabQuoteTimeChart = TabQuoteTimeChart;
